import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { ToastrService } from 'ngx-toastr';
import { Patterns, Guid, Utility } from 'src/app/core/common';
import { ApplyService } from 'src/app/services/apply.service';
import { PaymentService } from 'src/app/services/payment.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { Current } from 'src/app/states/auth.state';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-resume',
  templateUrl: './resume.component.html',
  styleUrls: ['./resume.component.scss'],
  // to apply header style in print
  encapsulation: ViewEncapsulation.None
})
export class ResumeComponent implements OnInit {
  Utility = Utility;
  assetsUrl = environment.app.assetsUrl;
  apply: any;
  jobs: any[];
  tags: any[];
  resumeCss: SafeHtml;
  resumeBody: string;

  constructor(
    private userService: UserService, private applyService: ApplyService, private sharedService: SharedService,
    private route: ActivatedRoute, private spinner: SpinnerService, private store: Store,
    private toastr: ToastrService, private paymentService: PaymentService,
    private router: Router, private sanitizer: DomSanitizer) {
  }
  get code() { return this._code; }
  @Input() set code(code: number) {
    if (!code || this._code === code) {
      delete this.seeker;
      delete this.apply;
      return;
    }
    this.inline = true;
    this._code = code;
    this.load();
  }
  @Input() showHeader = true;
  @Input() showSubscriptions = false;
  @Input() mobileView?: boolean = undefined;

  @Input('admin-mode') adminMode: boolean = false;

  @Input('whatsapp-message') whatsappMessage: string;

  get address() {
    return `${location.protocol}//${location.host}/resume/${this.seeker.Seeker.Code}`;
  }
  Math = Math;
  patterns = Patterns;
  location = location;

  seeker: any;
  loaded = false;
  payment: any;
  user: any;


  _code: number;
  inline: boolean;

  async ngOnInit() {

      if (this._code) {
    return;
  }

    this.route.params.subscribe(async params => {
      this.user = this.store.selectSnapshot(state => state.auth.user);
      if (params['code'] == 'search') {
        this.sharedService.redirectPermanent('/employer/seekers');
        return;
      }

      if (!isNaN(+params['code'])) {
        this.code = +params['code'];
      }
      if (this.user)
        this.loadMetadata();
    });
  }
  ngOnDestroy(): void {
    this.sharedService.resetNoIndex();
  }

  private async loadMetadata() {

    let metadata = await this.applyService.ownerGetListMetadata();

    if (metadata?.tags?.length)
      this.tags = metadata.tags.map(_ => _.tag);

    this.jobs = [{ Title: 'بدون آگهی', Id: Guid.Empty }, ...(metadata?.jobs || [])];
  }


  async load() {
    if (!this._code) { return; }
    this.spinner.show('load');
    
  // console.log('resume code:', this._code);
    this.seeker = await this.userService.getBySeekerCode(this._code);

    let templateData = await this.userService.getResumeInlineHtml(this._code, null, this.mobileView !== undefined ? this.mobileView : Utility.mobile);

    this.resumeCss = this.sanitizer.bypassSecurityTrustHtml(`<style>${templateData.css}</style>`);
    this.resumeBody = templateData.body;
    
    this.loaded = true;
    if (!this.seeker) return;

    if (this.user && (this.seeker.Id == this.user.Id || this.user.Employer)) {
      this.seeker = Object.assign(this.seeker, await this.userService.getSeekerFull(this.seeker.Id));
    }

    const pid = this.route.snapshot.queryParams['pid'];
    if (pid) {
      this.payment = await this.paymentService.get(pid);
    }
    this.spinner.hide('load');

    if (!this.inline)
      this.setSeo();

    if (!this.whatsappMessage)
      this.whatsappMessage = `${this.seeker.Name || 'کارجوی'} عزیز،
      از طریق سایت کارپیشه با شما آشنا شدیم،
      `;
  }

  share() {
    this.copy();
    if ((<any>navigator).share) {
      (<any>navigator).share({
        title: this.seeker.Seeker.CvTitle,
        url: this.address
      }// ).then(() => this.toastr.info('با تشکر از اشتراک گذاری')
      ).catch(() => this.copy());
    }
  }
  copy() {
    if (Utility.setClipboard(this.address)) {
      this.toastr.success('اطلاعات جهت اشتراک گذاری در حافظه موقت کپی شد');
    }
  }

  async downloadPdf() {
    this.spinner.show('load');
    let data = await this.userService.getResumeFile(this.seeker.Seeker.Code, 'pdf');
    this.sharedService.downloadBlob(data, 'application/pdf', this.seeker.Name);
    this.spinner.hide('load');
  }


  async buyResume(buyCredit = false) {
    if (buyCredit) {
      this.router.navigate(['/seeker', 'credit'], { queryParams: { rb: location.pathname + '?code=' + this._code } });
      return;
    }

    this.spinner.show('full-resume');
    if (this.user && this.user.Employer) {
      let user = await this.userService.buyResume(this.seeker.Id);
      this.seeker = Object.assign(this.seeker, user);
    }
    if (!this.seeker.Username) {
      this.router.navigate(['/seeker', 'credit'], { queryParams: { rb: location.pathname + '?code=' + this._code } });
    } else {
      this.toastr.success('این رزومه به لیست رزومه های خریداری شده شما اضافه شد.');
      await this.store.dispatch(Current).toPromise();
      this.user = this.store.selectSnapshot(state => state.auth.user);
      this.apply = await this.applyService.ownerGetByUserId(this.seeker.Id);
    }

    this.spinner.hide('full-resume');
  }

  private setSeo() {
    this.sharedService.setNoIndex();
    this.sharedService.setTitle('رزومه ' + this.seeker.Name);
    this.sharedService.removeLink('rel=\'canonical\'');
    this.sharedService.addLink({ rel: 'canonical', href: `${environment.app.url}/resume/${this._code}` });
    const keywords =
      (this.seeker.Seeker.Skills ? this.seeker.Seeker.Skills.map(_ => _.Title) : null)
      || (this.seeker.Seeker.CvTitle ? this.seeker.Seeker.CvTitle.split(' ') : null)
      || [];

    this.sharedService.setKeywordsMeta(...[<string>this.seeker.State, <string>this.seeker.City, ...keywords.slice(0, 10)]);
    this.sharedService.setDescriptionMeta((<string>this.seeker.Seeker.CvTitle || '') + keywords.slice(0, 10).join(' | '));
  }

  async updateApply(apply: any) {
    Object.assign(apply, await this.applyService.ownerUpdate(apply));
    this.tags = Utility.concatUnique(this.tags, apply.Tags);
  }

}
